import axios from "axios";
// import home from "../../home/home";
// import {
//   calculateTimeDifferenceTwoDates,
//   geDataFormat,
// } from "../../../common/utils";
// import user from "../../../common/mookup/mokup_ListaUser";
import jwt_decode from "jwt-decode";
import { logOut } from "../../../common/utils";

export default class manageProfileService {
  //   getDataChart(onSuccess) {
  //     var dataChart = [
  //       {
  //         name: "13/12/21",
  //         uv: 150,
  //       },
  //       {
  //         name: "14/12/21",
  //         uv: 110,
  //       },
  //       {
  //         name: "15/12/21",
  //         uv: 170,
  //       },
  //       {
  //         name: "16/12/21",
  //         uv: 180,
  //       },
  //       {
  //         name: "17/12/21",
  //         uv: 90,
  //       },
  //       {
  //         name: "18/12/21",
  //         uv: 0,
  //       },
  //       {
  //         name: "19/12/21",
  //         uv: 0,
  //       },
  //     ];
  //     onSuccess(dataChart);
  //   }

  getDataTableSanzioni(stato, onSuccess) {
    var headerDataTableSanzione = [
      { label: "Nome", field: "nome", width: 270 },
      { label: "Cognome", field:"cognome", width: 270 },
      // {
      //   label: "id_anagrafica_operatore",
      //   field: "id_anagrafica_operatore",
      //   width: 100,
      //   attributes: {
      //     "aria-controls": "DataTable",
      //     "aria-label": "Name",
      //     "display" :"none",
      //   },
      // },
      { label: "Numero Matricola", field: "numMatricola", width: 270 },
      { label: "E-mail", field: "email", width: 270 },
      { label: "Ruolo", field: "ruolo", width: 270 },
    ];
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios.get(host + "/api/v1/user/find/", configHeaders).then(
      function (result) {
        if(result.status === 401){
          logOut();
        }
        let dataTableUtenti = [];
        // console.log(result.data)
        result.data.map((result) => {
          dataTableUtenti = [
            ...dataTableUtenti,
            {
              nome: result.nome,
              cognome: result.cognome,
              numMatricola:result.numMatricola,
              email: result.email,
              ruolo:
                result.ruoliOperatori.nomeRuolo === "0"
                  ? "Verificatore"
                  : result.ruoliOperatori.nomeRuolo === "1"
                  ? "Operatore"
                  : result.ruoliOperatori.nomeRuolo === "2"
                  ? "Operatore Avanzato"
                  : result.ruoliOperatori.nomeRuolo === "3"
                  ? "?"
                  : result.ruoliOperatori.nomeRuolo === "4" ? "Admin" : "",//result.ruoliOperatori.nomeRuolo === "4" ? "Ruolo Da Definire" : result.ruoliOperatori.nomeRuolo === "5" ? "Ruolo Da definire 2" 
              idAnagraficaOperatore: result.idAnagraficaOperatore,
            },
          ];
        });
        // console.log(dataTableUtenti);
        onSuccess(headerDataTableSanzione, dataTableUtenti);
      },
      function (error) {
        if(error.response.status === 401){
          logOut();
        }
        console.log("errore ricerca composizione " + error);
        // onSuccess(headerDataTableSanzione, user);
      }
    );
  }

  saveUserIsert(user, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    let clienti= { idCliente: decoded.ID, attivo: 1,
    nome: "Linee Lecco",
    codiceFiscale: "92004770134",
    indirizzo: "P.zza Bione, 15 23900 Lecco",
    codiceUnivocoFatturazione: "",
    email: "info@nord-com.it" }
    user.clienti = clienti;
    // console.log(user);
    axios.post(host + "/api/v1/user/save", user, configHeaders).then(
      function (result) {
        if(result.status === 401){
          logOut();
        }
        // console.log(result.data);
        onSuccess(result);
      },
      function (error) {
        if(error.response.status === 401){
          logOut();
        }
        console.log("errore ricerca composizione " + error);
        // onSuccess(headerDataTableSanzione, user);
      }
    );
  }
}
